import { rootApi } from '../rootApi';

// Identity API: yetki kataloğu, rol-yetki matrisi ve kullanıcı rolleri.
// v1/permission ve v1/role istekleri base.js'te Identity sunucusuna yönlenir.
const unwrap = (response) => response?.data;

export const permissionManagementApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getPermissionCatalog: builder.query({
            query: () => ({ url: 'v1/permission/catalog', method: 'GET' }),
            transformResponse: unwrap,
            providesTags: ['PermissionCatalog']
        }),
        getIdentityRoles: builder.query({
            query: () => ({ url: 'v1/role', method: 'GET' }),
            transformResponse: unwrap,
            providesTags: ['IdentityRoles']
        }),
        createIdentityRole: builder.mutation({
            query: ({ name }) => ({ url: 'v1/role', method: 'POST', body: { name, claims: [] } }),
            transformResponse: unwrap,
            invalidatesTags: ['IdentityRoles', 'AssignableRoles']
        }),
        getIdentityRolePermissions: builder.query({
            query: (roleId) => ({ url: `v1/permission/role/${roleId}`, method: 'GET' }),
            transformResponse: unwrap,
            providesTags: (result, error, roleId) => [{ type: 'IdentityRolePermissions', id: roleId }]
        }),
        setIdentityRolePermissions: builder.mutation({
            query: ({ roleId, permissions }) => ({ url: `v1/permission/role/${roleId}`, method: 'PUT', body: { permissions } }),
            transformResponse: unwrap,
            invalidatesTags: (result, error, { roleId }) => [{ type: 'IdentityRolePermissions', id: roleId }, 'UserEffectivePermissions']
        }),
        getIdentityRoleSettings: builder.query({
            query: (roleId) => ({ url: `v1/permission/role/${roleId}/settings`, method: 'GET' }),
            transformResponse: unwrap,
            providesTags: (result, error, roleId) => [{ type: 'IdentityRoleSettings', id: roleId }]
        }),
        setIdentityRoleSettings: builder.mutation({
            query: ({ roleId, ...settings }) => ({ url: `v1/permission/role/${roleId}/settings`, method: 'PUT', body: settings }),
            transformResponse: unwrap,
            invalidatesTags: (result, error, { roleId }) => [{ type: 'IdentityRoleSettings', id: roleId }, 'AssignableRoles', 'UserEffectivePermissions']
        }),
        getAssignableRoles: builder.query({
            query: (userType) => ({ url: 'v1/permission/assignable-roles', method: 'GET', params: { userType } }),
            transformResponse: unwrap,
            providesTags: ['AssignableRoles']
        }),
        getUserModuleRoles: builder.query({
            query: (userId) => ({ url: `v1/permission/user/${userId}/roles`, method: 'GET' }),
            transformResponse: unwrap,
            providesTags: (result, error, userId) => [{ type: 'UserModuleRoles', id: userId }]
        }),
        setUserModuleRoles: builder.mutation({
            query: ({ userId, userType, roleIds }) => ({ url: `v1/permission/user/${userId}/roles`, method: 'PUT', body: { userType, roleIds } }),
            transformResponse: unwrap,
            invalidatesTags: (result, error, { userId }) => [
                { type: 'UserModuleRoles', id: userId },
                { type: 'UserEffectivePermissions', id: userId }
            ]
        }),
        getUserEffectivePermissions: builder.query({
            query: (userId) => ({ url: `v1/permission/user/${userId}`, method: 'GET' }),
            transformResponse: unwrap,
            providesTags: (result, error, userId) => [{ type: 'UserEffectivePermissions', id: userId }]
        }),
        getMyPermissions: builder.query({
            query: () => ({ url: 'v1/permission/me', method: 'GET' }),
            // Uç henüz her ortamda yok; hata olursa eski rol kontrolleri devam eder, toast gösterilmez
            extraOptions: { silentError: true },
            transformResponse: unwrap,
            providesTags: ['MyPermissions']
        })
    }),
    overrideExisting: false
});

export const {
    useGetPermissionCatalogQuery,
    useGetIdentityRolesQuery,
    useCreateIdentityRoleMutation,
    useGetIdentityRolePermissionsQuery,
    useSetIdentityRolePermissionsMutation,
    useGetIdentityRoleSettingsQuery,
    useSetIdentityRoleSettingsMutation,
    useGetAssignableRolesQuery,
    useGetUserModuleRolesQuery,
    useLazyGetUserModuleRolesQuery,
    useSetUserModuleRolesMutation,
    useGetUserEffectivePermissionsQuery,
    useGetMyPermissionsQuery
} = permissionManagementApi;
